<template>
  <v-tooltip
    :open-delay="openDelay"
    :max-width="maxWidth"
    :top="top"
    :bottom="bottom"
    :left="left"
    :color="color"
    :right="right">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <slot></slot>
      </span>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>

</template>

<script>
/**
 * Wraps v-tooltip to implement a tooltip in a (hopefully) simpler, more conventional way
 */
export default {
  name: 'VfTooltip',
  props: {
    // Pass-through fields
    openDelay: {
      type: Number,
      default: 500
    },
    color: {
      type: String,
      default: 'primary-900'
    },
    maxWidth: {
      type: Number
    },
    bottom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    // The tooltip text to display.
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * If no other direction is selected, we default to a top tooltip.
     * @returns {boolean}
     */
    top () {
      return !(this.bottom || this.left || this.right)
    }
  }
}
</script>

<style scoped>

</style>
